<template>
  <svg :class="nameClass">
    <use :xlink:href="hrefName" width="100%" height="100%" />
  </svg>
</template>

<script>
export default {
  name: "include-svg",
  props: {
    name: String
  },
  computed: {
    nameClass() {
      return `sm-svg-icon sm-${this.name}`;
    },
    hrefName() {
      return `#${this.name}`;
    }
  }
};
</script>